(() => {
  if (customElements.get('ez-card-motion')) return;
  const allowed = matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
  class CardMotion extends HTMLElement {
    connectedCallback() {
      this.card = this.closest('product-card');
      this.media = this.querySelector('video, img');
      if (!this.card || !this.media) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.card.addEventListener('mouseenter', () => this.start(), options);
      this.card.addEventListener('mouseleave', () => this.stop(), options);
      this.card.addEventListener('focusin', () => this.start(), options);
      this.card.addEventListener('focusout', (event) => {
        if (!this.card.contains(event.relatedTarget)) this.stop();
      }, options);
      this.media.addEventListener(this.media.tagName === 'VIDEO' ? 'playing' : 'load', () => {
        if (this.active && allowed.matches) this.classList.add('is-playing');
      }, options);
      this.media.addEventListener('error', () => this.stop(), options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
      }, options);
      allowed.addEventListener('change', () => {
        if (!allowed.matches) this.stop();
      }, options);
      if (this.card.matches(':hover') || this.card.contains(document.activeElement)) this.start();
    }
    start() {
      if (!allowed.matches || !this.media || document.hidden) return;
      this.active = true;
      if (!this.media.getAttribute('src')) this.media.src = this.media.dataset.src;
      if (this.media.tagName === 'VIDEO') {
        this.media.muted = true;
        this.media.play().catch(() => this.classList.remove('is-playing'));
      } else if (this.media.complete && this.media.naturalWidth > 0) {
        this.classList.add('is-playing');
      }
    }
    stop() {
      this.active = false;
      this.classList.remove('is-playing');
      if (this.media?.tagName === 'VIDEO') {
        this.media.pause();
        if (this.media.readyState > 0) this.media.currentTime = 0;
      }
    }
    disconnectedCallback() {
      this.stop();
      this.events?.abort();
    }
  }
  customElements.define('ez-card-motion', CardMotion);
})();
